import { useEffect, useRef, useState } from "react";
import { Shield, UserRound } from "lucide-react";
import { canRenderExternalMedia } from "@/media";

// Repli = état INITIAL : une silhouette neutre (jamais d'initiales, décision 04/10/2026).
// L'image externe ne le remplace qu'une fois chargée ; une erreur de chargement le laisse en place.
export function Silhouette({ kind = "player", size, radius = "rounded-lg", className = "", testid }) {
  const Icon = kind === "player" ? UserRound : Shield;
  const style = size ? { width: size, height: size } : undefined;
  return (
    <span data-testid={testid} aria-hidden="true" style={style}
      className={`inline-flex shrink-0 items-center justify-center border border-[#1F293D] bg-[#0B0E14] text-slate-600 ${radius} ${className}`}>
      <Icon className="h-[55%] w-[55%]" strokeWidth={1.25} />
    </span>
  );
}

// `size` en px (carré) ; sans `size`, le bloc est fluide : pleine largeur, ratio 1:1.
export default function MediaImage({ src, alt, kind = "player", size, surface, radius = "rounded-lg", className = "", imgClassName = "", testid }) {
  const allowed = canRenderExternalMedia(surface) && !!src;
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    setLoaded(false); setFailed(false);
    // Image déjà en cache : `onLoad` a pu partir avant l'attache du gestionnaire.
    const el = ref.current;
    if (el && el.complete) { if (el.naturalWidth > 0) setLoaded(true); else setFailed(true); }
  }, [src]);
  const showImg = allowed && !failed;
  const dim = size ? { width: size, height: size } : undefined;
  return (
    <span className={`relative shrink-0 ${size ? "inline-block" : "block w-full aspect-square"} ${className}`} style={dim} data-testid={testid}>
      {(!showImg || !loaded) && (
        <Silhouette kind={kind} radius={radius} testid={testid ? `${testid}-fallback` : undefined} className="absolute inset-0 h-full w-full" />
      )}
      {showImg && (
        <img
          ref={ref}
          src={src}
          alt={alt}
          width={size || 300}
          height={size || 300}
          loading="lazy"
          decoding="async"
          referrerPolicy="no-referrer"
          onLoad={() => setLoaded(true)}
          onError={() => setFailed(true)}
          data-testid={testid ? `${testid}-img` : undefined}
          className={`absolute inset-0 h-full w-full border border-[#1F293D] bg-[#0B0E14] object-cover transition-opacity duration-300 ${radius} ${loaded ? "opacity-100" : "opacity-0"} ${imgClassName}`}
        />
      )}
    </span>
  );
}
